module.exports = __webpack_public_path__ + "static/chip_s-eccc93276cc8610a50177d71a37bfaa1.svg";